module.exports = __webpack_public_path__ + "static/media/sopt14kz.8b3403b2.pdf";